import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ErrorCode, RecipientsApi, RestApiError, type RecipientResponse, type UpdateRecipientRequest } from '@shared/api';

const ERROR_CODES = [ErrorCode.TRP_VAL_008, ErrorCode.TRP_VAL_009, ErrorCode.TRP_VAL_010, ErrorCode.TRP_VAL_011];

const updateRecipientEffect = createEffect((request: UpdateRecipientRequest) => RecipientsApi.updateRecipient(request));
const clearEvent = createEvent();

const $dataStore = createStore<RecipientResponse | null>(null)
  .on(updateRecipientEffect.done, (_, data) => data.result.data ?? null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(updateRecipientEffect.pending, (_, data) => data)
  .on(updateRecipientEffect.fail, () => false)
  .on(updateRecipientEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<{ message: string; errorCode?: ErrorCode } | null>(null)
  // .on(updateRecipientEffect, () => null)
  .on(updateRecipientEffect.fail, (_, data) => {
    if (RestApiError.isRestApiError(data.error) && data.error.data.errorCode) {
      if (ERROR_CODES.includes(data.error.data.errorCode)) return { errorCode: data.error.data.errorCode, message: data.error.data.message };
      return { message: data.error.message };
    }
    return { message: 'Something went wrong while updating Recipient. Please try again.' };
  })
  .on(updateRecipientEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error?.errorCode ? null : error?.message));

export const $recipientUpdateStore = {
  events: {
    updateRecipient: updateRecipientEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
